import "./layout.scss";

import HeadboardBreadcrumbs, {
  headboardBreadcrumbsAdapter,
} from "../../molecules/headboard-breadcrumbs";
import HeadboardSimple, {
  headboardSimpleAdapter,
} from "../../molecules/headboard-simple";
import React, { useEffect, useState } from "react";

import CoverEnterprises from "../../atoms/cover-enterprises/cover-enterprises";
import CoverServices from "../../atoms/cover-services/cover-services";
import Footer from "../../molecules/footer/footer";
import HeadboardButtons from "../headboard-buttons/headboardButtons";
import Header from "../../molecules/header/header";
import LayoutContext from "../../../contexts/layoutContext";
import NewNavbar from "../../molecules/new-navbar/newNavbar";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useChangeTheme from "../../../shared/hooks/useChangeTheme";

interface LayoutInterface {
  categoryName?: string;
  children?: any;
  headboard?: ReferenciaCabecera;
  isNotRoot?: boolean;
  hideHeaderDesktop: boolean;
  hideHeaderMobile: boolean;
  typeChat?: string;
}
const Layout = (props: LayoutInterface) => {
  const [isMenuActive, setMenuActive] = useState(false);
  const [_scrollActive, setScrollActive] = useState(false);
  const [indexServices, setIndexServices] = useState(0);
  const [isDark, changeDarkMode] = useChangeTheme();
  const scrollActive = { get: _scrollActive, set: setScrollActive };
  const [size, setSize] = useState(0);
  const {
    isBrowser,
    localStorage,
    sessionStorage,
    document,
  } = useBrowserMode();
  const [isSearcherActive, setSearcherActive] = useState(false);

  useEffect(() => {
    if (isBrowser) {
      const realSize = parseInt(localStorage.getItem("font-size") || "100");
      const item = document.querySelector("html") || {
        style: { fontSize: realSize },
      };
      item.style.fontSize = `${realSize}%`;
      setSize(realSize);
      toLocalStoragepageActive();
      setShowMsg();
    }
    return () => {
      // isBrowser && document.removeEventListener('scroll', onScrollAction);
    };
  }, []);

  const doSetSize = (_size: number) => {
    localStorage.setItem("font-size", `${_size}`);
    setSize(_size);
  };

  const context = {
    fontSize: { get: size, set: doSetSize },
    slideServices: { get: indexServices, set: setIndexServices },
  };

  const toLocalStoragepageActive = () => {
    if (localStorage.getItem("Redirection")) {
      const data = JSON.parse(localStorage.getItem("Redirection"));
      if (data.titleButton === "NUTRICION SALUDABLE") {
        return false;
      } else {
        return localStorage.setItem(
          "Redirection",
          JSON.stringify({
            titleButton: "NUTRICION SALUDABLE",
            path: "nutricion-saludable",
          })
        );
      }
    } else {
      return localStorage.setItem(
        "Redirection",
        JSON.stringify({
          titleButton: "NUTRICION SALUDABLE",
          path: "nutricion-saludable",
        })
      );
    }
  };

  const switchHeadBoard = (headboard: ReferenciaCabecera) => {
    switch (headboard.tipoCabecera) {
      case "CabeceraPrincipal":
        return <CoverServices coverData={headboard} />;
      case "CabeceraBotones":
        return <HeadboardButtons {...headboard} />;
      case "CabeceraSimple":
        return <CoverEnterprises {...headboard} />;
      // nueva cabecera nutricion saludable 2.0
      case "CabeceraPaginas":
        return <HeadboardSimple {...headboardSimpleAdapter(headboard)} />;
      case "CabeceraMigaDePan":
        return (
          <HeadboardBreadcrumbs {...headboardBreadcrumbsAdapter(headboard)} />
        );
      case "SinCabecera":
        return "";
      default:
        return <CoverServices coverData={headboard} />;
    }
  };

  let setShowMsg = () => {
    if (!sessionStorage.getItem("showMsg")) {
      sessionStorage.setItem("showMsg", "true");
    }
  };

  return (
    <LayoutContext.Provider value={context}>
      {/* <Header
        categoryName={props.categoryName}
        isSearcherActive={isSearcherActive}
        scrollActive={scrollActive}
        isMenuActive={isMenuActive}
        isDark={isDark}
        setMenuActive={setMenuActive}
        actionTheme={changeDarkMode}
        setSearcherActive={setSearcherActive}
        hideHeaderDesktop={true}
      /> */}
      <NewNavbar />
      {/* <NavMenu
        isMenuActive={isMenuActive}
        setMenuActive={setMenuActive}
        isSearcherActive={isSearcherActive}
      /> */}
      {/* <PersonMenu onPersonChange={() => {}} onMenuToggle={() => onMenuToggle} /> */}
      {props.headboard && switchHeadBoard(props.headboard)}
      <main>{props.children}</main>
      <Footer />
    </LayoutContext.Provider>
  );
};

export default Layout;
